import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { addIcons } from 'ionicons';
import { home, barChart, personCircle } from 'ionicons/icons';
import {
  IonTabs,
  IonTabBar,
  IonTabButton,
  IonIcon,
} from '@ionic/angular/standalone';
import { NgClass, AsyncPipe } from '@angular/common';
import { AdService } from '@app/ads.service';
import { distinctUntilChanged, firstValueFrom } from 'rxjs';
import { UserService } from '@app/services/user.service';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.page.html',
  styleUrls: ['./tabs.page.scss'],
  imports: [IonTabs, NgClass, IonTabBar, IonTabButton, IonIcon, AsyncPipe],
})
export class TabsPage {
  public readonly route = inject(ActivatedRoute);
  public readonly userService = inject(UserService);
  public readonly adService = inject(AdService);
  private areAdsInitialized = false;

  constructor() {
    addIcons({ home, barChart, personCircle });
  }


  async ionViewWillEnter() {

    this.userService.membership$
      .pipe(distinctUntilChanged())
      .subscribe(async (membership) => {
        const shouldShowAds =
          membership.type === 'none';

        if (!this.areAdsInitialized) {
          await this.adService.initialize();
          this.areAdsInitialized = true;
        }

        this.adService.configureAds({
          enabled: shouldShowAds,
          userId: await firstValueFrom(this.userService.uid$),
        });

        if (shouldShowAds) {
          await this.adService.showBanner();
        }
      });
  }
}
